import dic from '@/assets/dictionary/index.js'
import { LANG } from '@/libs/constants'
const { sectionPositions } = dic[LANG]

export const newPositionList = (sectionPositions) => [
  {
    id: '1',
    label: sectionPositions.list[1],
    img: '1.png',
  },
  {
    id: '2',
    label: sectionPositions.list[2],
    img: '2.png',
  },
  {
    id: '3',
    label: sectionPositions.list[3],
    img: '3.png',
  },
]

export default {
  namespaced: true,
  state: {
    imgDir: 'positions',
    positionList: newPositionList(sectionPositions),
  },

  getters: {
    getPositionList: function(state) {
      return state.positionList.map(function({ label, img }) {
        return {
          label,
          img,
          imgSrc: require(`@/assets/img/${state.imgDir}/${img}`),
        }
      })
    },
  },
}
